<template>
  <Tabs id="editTabPanel" type="card" v-model="defaultProject" v-if="showTabs.length > 0">

    <TabPane label="体检项目" name="physicalProject" v-if="showTabs.indexOf('physicalProject') > -1">
      <el-input placeholder="输入关键字进行过滤" v-model="filterProjectText" clearable style="width: 50%;margin-bottom: 3px;"/>

      <FormItem :label-width="0" :style="{'max-height': maxHeight, 'overflow-y': 'auto'}">
        <el-tree ref="projectTree" class="treeBox" :data="projectsTreeData" show-checkbox node-key="id" :filter-node-method="filterNode"
          :check-strictly="true" :highlight-current="true" :expand-on-click-node="false" @check-change="projectIdsCheck">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <div class="custom-tree-node-content">{{ node.label }}</div>
            <div class="custom-tree-node-content" v-if="model ==='table' ">
              <span style="margin-left: 15px;" v-if="localApplicableAgeList&&localApplicableAgeList.length>0">
                报名展示: <el-switch active-color="#13ce66" :active-value="1"  :inactive-value="2" inactive-color="#c0c4cc" size="mini" :value="data.appShow"
                                     @change="(val)=>{handleProjectsTreeDataChange('appShow',data,val)}" :disabled="disabled"/>
              </span>
               <span v-if="localApplicableAgeList&&localApplicableAgeList.length>0">
                 <el-select :value="data.startApplicableAgeId" placeholder="适用年龄" :disabled="disabled"
                            clearable  placement="top" transfer size="mini" style="width: 100px;" @change="(val)=>{handleProjectsTreeDataChange('startApplicableAgeId',data,val)}">
                    <el-option v-for="item in localApplicableAgeList"
                               :key="item.id" :value="item.value" :label="item.label" style="width:100px;"/>
                  </el-select>
                 <el-select :value="data.endApplicableAgeId" placeholder="适用年龄" :disabled="disabled"
                            clearable  placement="top" transfer size="mini" style="width: 100px;" @change="(val)=>{handleProjectsTreeDataChange('endApplicableAgeId',data,val)}">
                    <el-option v-for="item in localApplicableAgeList"
                               :key="item.id" :value="item.value" :label="item.label"
                               style="width:100px;"/>
                  </el-select>
              </span>
              <span >
                <el-select :value="data.projectType" placeholder="请选择项目类型" :disabled="disabled"
                           clearable  placement="top" transfer size="mini" style="width: 120px;" @change="(val)=>{handleProjectsTreeDataChange('projectType',data,val)}">
                  <el-option v-for="item in lisProjectTypes"
                             :key="item.id" :value="item.value" :label="item.label"
                             style="width:120px;z-index: 9999;"/>
                </el-select>
              </span>
              <span >
                价格: <Input type="text" placeholder="请输入价格" style="width:70px;"
                       v-model="data.price" @on-keyup="changeinput(data,'price', data.price)"
                       @input="(val)=>{handleLisProjectsTreeDataChange('price',data,val)}" :disabled="disabled"/>
              </span>
            </div>
          </span>
        </el-tree>
      </FormItem>
    </TabPane>

    <TabPane label="Lis项目" name="lisProject" v-if="showTabs.indexOf('lisProject') > -1">
      <el-input placeholder="输入关键字进行过滤" v-model="filterLisProjectText" clearable style="width: 50%;margin-bottom: 3px;"/>
      <FormItem :label-width="0" :style="{'max-height': maxHeight, 'overflow-y': 'auto'}">
        <el-tree ref="lisProjectTree" :data="lisProjectsTreeData" show-checkbox node-key="id" :filter-node-method="filterNode"
                 :check-strictly="true" :highlight-current="true" :expand-on-click-node="false" @check-change="lisProjectIdsCheck">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <div class="custom-tree-node-content">{{ node.label }}</div>
            <div class="custom-tree-node-content" v-if="model ==='table' && data.showCheckbox !== false">
              <span>
                <el-select :value="data.projectType" placeholder="请选择项目类型" clearable  placement="top" transfer size="mini" style="width: 120px;"
                           @change="(val)=>{handleLisProjectsTreeDataChange('projectType',data,val)}" :disabled="disabled">
                  <el-option v-for="item in lisProjectTypes" :key="item.id" :value="item.value" :label="item.label"  style="width:120px;z-index: 9999;"/>
                </el-select>
              </span>
              <span>
                价格:
                <Input type="text" placeholder="请输入价格" style="width:70px;"
                       v-model="data.price" @on-keyup="changeinput(data,'price', data.price)"
                       @input="(val)=>{handleLisProjectsTreeDataChange('price',data,val)}" :disabled="disabled"/>
              </span>
            </div>
          </span>
        </el-tree>
      </FormItem>
    </TabPane>
  </Tabs>
</template>
<script>
import {mixins} from "@/mixins";

export default {
  name: "EditTabPanel",
  mixins: [mixins],
  data() {
    return {
      lisProjectTypes:[
        {label: '默认项目', value: 1},
        {label: '自费项目', value: 2},
        {label: '加做项目', value: 3},
      ],
      filterProjectText:"",
      filterLisProjectText:"",
      defaultProject: '',
      loading:false,
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      projectsTreeData:[],
      lisProjectsTreeData:[],
    }
  },
  props: {
    model: {
      type: String,
      default: () => {
        return 'simple';
      }
    },
    disabled:{
      type: Boolean,
      default: () => {
        return false;
      }
    },
    packagesId: {
      type: String,
      default: () => {
        return '';
      }
    },
    showTabs: {
      type: Array,
      default: () => {
        return ['physicalProject', 'lisProject'];
      }
    },
    taskProjects: {
      type: Array,
      default: () => {
        return [];
      }
    },
    taskLisProjects: {
      type: Array,
      default: () => {
        return [];
      }
    },
    projectIds: {
      type: Array,
      default: () => {
        return [];
      }
    },
    lisProjectIds: {
      type: Array,
      default: () => {
        return [];
      }
    },
    localApplicableAgeList:{
      type:Array,
      default:()=>{
        return [];
      }
    },
    maxHeight: {
      type: String,
      default: () => {
        return '280px';
      }
    },
  },
  watch: {
    filterProjectText(val) {
      this.$refs.projectTree.filter(val);
    },
    filterLisProjectText(val) {
      this.$refs.lisProjectTree.filter(val);
    },
    projectIds:{
      handler(newVal){
        if (newVal){
          if(!this.disabled){
            for (let index = 0; index < this.projectsTreeData.length; index++) {
              this.projectsTreeData[index]['disabled'] = this.disabled;
            }
          }
          this.$refs.projectTree.setCheckedKeys(newVal);
        }else {
          this.$refs.projectTree.setCheckedKeys([]);
        }
      }
    },
    lisProjectIds:{
      handler(newVal){
        if (newVal){
          if(!this.disabled){
            for (let index = 0; index < this.lisProjectsTreeData.length; index++) {
              this.lisProjectsTreeData[index]['disabled'] = this.disabled;
            }
          }
          this.$refs.lisProjectTree.setCheckedKeys(newVal);
        }else {
          this.$refs.lisProjectTree.setCheckedKeys([]);
        }
      }
    }
  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.loadProjects();
      this.loadLisProjects();
      this.$forceUpdate()
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //####################处理体检项目######################start
    projectIdsCheck(){
      let ids = this.$refs.projectTree.getCheckedKeys();
      this.$emit("update:projectIds",ids);
      if (this.$props.model === 'table'){
        this.handleProjectsTreeDataChange()
      }
    },
    async loadProjects() {
      this.loading=true;
      let res = await this.applyPhysicalProjectList();
      let tempList=[]
      let projectIds = [];
      if(res){
        res.forEach(item => {
          //选中的数据
          let project = this.$props.taskProjects.find(_project => {
            return (_project.projectId + '') === (item.value + '')
          })
          if (project && project.status && project.status == 2){
            projectIds.push(project.projectId)
          }
          tempList.push({
            id: item.value,
            pid: item.pid,
            label: item.label,
            value:item.value,
            appShow: project ? project.appShow : 1,
            startApplicableAgeId: project ? project.startApplicableAgeId : '',
            endApplicableAgeId: project ? project.endApplicableAgeId : '',
            status: project ? project.status : 1,
            projectType: project ? project.projectType : 1,
            projectId: item.id,
            projectName: item.name,
            disabled: item.status == 2 ? true : this.disabled,
            price: project && project.price ? project.price : "0.00",
          })
        })
      }

      this.projectsTreeData = tempList;
      this.loading=false;
      this.$nextTick(()=>{
        if (this.$props.model==='table'){
          this.handleProjectsTreeDataChange();
          this.$emit("update:projectIds",projectIds);
        }else{
          this.$refs.projectTree.setCheckedKeys(this.$props.projectIds);
        }
      })
    },
    //修改参数值,并重新组装参数,把值通过事件传出去
    handleProjectsTreeDataChange(paramName, data, val){
      let resultData = []
      let ids = this.$refs.projectTree.getCheckedKeys();
      for (let index = 0; index < this.projectsTreeData.length; index++) {
        let item = this.projectsTreeData[index]
        if (paramName && data){
          if (item.value === data.value){
            this.projectsTreeData[index][paramName] = val;
          }
        }
        resultData.push({
          appShow: this.projectsTreeData[index].appShow,
          startApplicableAgeId: this.projectsTreeData[index].startApplicableAgeId,
          endApplicableAgeId: this.projectsTreeData[index].endApplicableAgeId,
          price: this.projectsTreeData[index].price,
          projectId: this.projectsTreeData[index].id,
          projectName: this.projectsTreeData[index].label,
          projectType: this.projectsTreeData[index].projectType,
          status: ids.indexOf(this.projectsTreeData[index].id) > -1 ? 2 :1,
          disabled: this.projectsTreeData[index].status == 2 ? true : this.projectsTreeData[index].disabled
        })
      }
      this.$emit("setTaskProjects", this.packagesId,"taskProjects",resultData)
    },
    //####################处理体检项目######################end

    //####################处理lis项目######################start
    lisProjectIdsCheck(){
      let ids = this.$refs.lisProjectTree.getCheckedKeys();
      this.$emit("update:lisProjectIds",ids);
      if (this.$props.model === 'table'){
        this.handleLisProjectsTreeDataChange()
      }
    },
    async loadLisProjects() {
      this.loading=true;
      let res = await this.applyLisProjectList();
      let tempList=[]
      let lisProjectIds = [];
      if(res){
        res.forEach(item => {
          let lisProject = this.$props.taskLisProjects.find(_lisProject => {
            return _lisProject.lisProjectId+'' === item.value+''
          })
          if (lisProject && lisProject.status && lisProject.status == 2){
            lisProjectIds.push(lisProject.lisProjectId)
          }
          let children = [];
          if (item.children) {
            item.children.forEach(subItem => {
              let child = undefined;
              if (lisProject && lisProject.children){
                child = lisProject.children.find(sub => {
                  return sub.id === subItem.value
                })
              }
              children.push({
                id: subItem.value,
                value:subItem.value,
                label: subItem.label ? subItem.label : subItem.name,
                code: subItem.code,
                pid: subItem.pid,
                name: child ? child.name : subItem.name,
                price: "0.00",
                disabled:true,
                showCheckbox: false,
              })
            })
          }

          tempList.push({
            id: item.value,
            value:item.value,
            pid: item.pid,
            label: item.label + "(" + item.code + ")" + "(" + item.bloodTubeName + ")",
            code: item.code,
            children: children,
            status: lisProject ? lisProject.status : 1,
            projectType: lisProject ? lisProject.projectType : 1,
            price: lisProject && lisProject.price ? lisProject.price : "0.00",
            lisProjectCode: lisProject ? lisProject.code : '',
            lisProjectName: lisProject ? lisProject.name : '',
            disabled: this.disabled,
            lisProjectId: item.id
          })
        })
      }
      this.lisProjectsTreeData = tempList;

      this.loading=false;
      this.$nextTick(()=>{
        if (this.$props.model==='table'){
          this.handleLisProjectsTreeDataChange()
          this.$emit("update:lisProjectIds",lisProjectIds);
        }else {
          this.$refs.lisProjectTree.setCheckedKeys(this.$props.lisProjectIds);
        }
      })
    },
    //修改参数值,并重新组装参数,把值通过事件传出去
    handleLisProjectsTreeDataChange(paramName,data,val){
      let resultData=[]
      let ids = this.$refs.lisProjectTree.getCheckedKeys();
      for (let index = 0; index < this.lisProjectsTreeData.length; index++) {
        let item = this.lisProjectsTreeData[index]
        if (paramName && data){
          if (item.value === data.value){
            this.lisProjectsTreeData[index][paramName] = val;
          }
        }
        resultData.push({
          lisProjectCode: this.lisProjectsTreeData[index].lisProjectCode,
          lisProjectId: this.lisProjectsTreeData[index].lisProjectId,
          lisProjectName: this.lisProjectsTreeData[index].lisProjectName,
          price: this.lisProjectsTreeData[index].price,
          projectType: this.lisProjectsTreeData[index].projectType,
          status: ids.indexOf(this.lisProjectsTreeData[index].lisProjectId) > -1 ? 2 :1,
          disabled: this.lisProjectsTreeData[index].disabled
        })
      }
      this.$emit("setTaskProjects", this.$props.packagesId,"taskLisProjects",resultData)
    },
    //####################处理lis项目######################end
    changeinput(data, fieldName, value){
      if(!value){
        return;
      }
      data[fieldName] = value
      data[fieldName] = data[fieldName].replace(/[^\d.]/g, '');
      data[fieldName] = data[fieldName].replace(/^\./g, '');
      data[fieldName] = data[fieldName].replace(/\.{2,}/g, '');
      data[fieldName] = data[fieldName].replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');

      if (data[fieldName].indexOf('.') !== -1 && data[fieldName].length > 10) {
        data[fieldName] = data[fieldName].substring(0,10);
      }

      let count = -1
      for (let i in data[fieldName]) {
        if (data[fieldName][i] === '.') {
          count = i
        }
        if (count !== -1) {
          if ((i - count) > 2) {
            data[fieldName] = data[fieldName].substring(0, data[fieldName].length - 1)
          }
        }
      }
    },
  }
};
</script>
<style lang="postcss" scoped>
#editTabPanel {min-height: 300px;}
.treeBox{min-width: 600px;overflow-x: auto;overflow-y: hidden;}
.custom-tree-node {flex: 1;display: flex;align-items: center;justify-content: space-between;font-size: 14px;}
.custom-tree-node .custom-tree-node-content{display: flex;justify-content: space-between;}
.custom-tree-node .custom-tree-node-content span{margin-left: 3px;}
.disable-area{pointer-events: none;opacity: 0.7;}
/deep/ .el-tree-node__content>.el-tree-node__expand-icon {padding: 0px;}
/deep/ .el-input__inner {height: 35px;line-height: 35px;}
/deep/ .el-input__icon{line-height: 35px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}
/deep/ .el-tree-node{margin: 10px 0}
</style>
